import { defineMessages } from "react-intl";

export const messages = defineMessages({
  sectionCheckoutTitle: {
    id: "DASYUF",
    defaultMessage: "Checkout Configuration",
    description: "section title",
  },
  sectionCheckoutDescription: {
    id: "Av74Fa",
    defaultMessage:
      "You can set basic checkout rules that will be applied globally to all your channels",
    description: "section description",
  },
  sectionCompanyTitle: {
    id: "rPX1f2",
    defaultMessage: "Company Information",
    description: "section title",
  },
  sectionCompanyDescription: {
    id: "pRYGUR",
    defaultMessage:
      "This address will be used to generate invoices and calculate shipping rates. Email address you provide here will be used as a contact address for your customers.",
    description: "section description",
  },
  sectionEmailConfirmationTitle: {
    id: "qNeXG1",
    defaultMessage: "User registration",
    description: "User registration",
  },
  sectionEmailConfirmationHeader: {
    id: "kpRxSA",
    defaultMessage: "Require email confirmation link",
    description: "Require email confirmation link",
  },
  sectionEmailConfirmationOption: {
    id: "uRfta0",
    defaultMessage: "Enable email confirmation",
    description: "Enable email confirmation",
  },
  sectionEmailConfirmationDescription: {
    id: "/xJSe8",
    defaultMessage:
      "When users confirm their email account, all previous anonymous orders placed under the same email would be added to their order history.",
    description:
      "When users confirm their email account, all previous anonymous orders placed under the same email would be added to their order history.",
  },
});
